import { Box, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

const ProfileSupport: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box className="notranslate" translate="no">
      <Typography
        variant="h5"
        sx={{ fontWeight: 600, mb: 3 }}
        className="notranslate"
        translate="no"
      >
        {t("profile.supportTickets")}
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
        className="notranslate"
        translate="no"
      >
        {t("profile.supportTicketsComingSoon")}
      </Typography>
    </Box>
  );
};

export default ProfileSupport;
